import React from 'react'
import PropTypes from 'prop-types'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  ResponsiveBreakpointsProvider,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import useResponsiveBreakpointsRollout, {
  RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS
} from 'utils/hooks/useResponsiveBreakpointsRollout'

const DISPLAY_CONTENTS_STYLE = Object.freeze({ display: 'contents' })

const ReleaseInformationVersionMarker = ({ children, isPending }) => {
  const version = useResponsiveBreakpointsVersion()

  return (
    <div
      aria-busy={isPending || undefined}
      data-responsive-breakpoints={version}
      data-responsive-breakpoints-page={
        RESPONSIVE_BREAKPOINT_PAGES.RELEASE_INFORMATION
      }
      data-responsive-breakpoints-status={isPending ? 'pending' : undefined}
      style={DISPLAY_CONTENTS_STYLE}
    >
      {children}
    </div>
  )
}

ReleaseInformationVersionMarker.propTypes = {
  children: PropTypes.node.isRequired,
  isPending: PropTypes.bool.isRequired
}

const ReleaseInformationWithRollout = ({ children }) => {
  const rolloutStatus = useResponsiveBreakpointsRollout(
    RESPONSIVE_BREAKPOINT_PAGES.RELEASE_INFORMATION
  )
  const isPending =
    rolloutStatus === RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.PENDING
  const version = isPending
    ? RESPONSIVE_BREAKPOINT_VERSIONS.LEGACY
    : rolloutStatus

  return (
    <ResponsiveBreakpointsProvider value={version}>
      <ReleaseInformationVersionMarker isPending={isPending}>
        {children}
      </ReleaseInformationVersionMarker>
    </ResponsiveBreakpointsProvider>
  )
}

ReleaseInformationWithRollout.propTypes = {
  children: PropTypes.node.isRequired
}

export default ReleaseInformationWithRollout
